/**
 * Read a required string from import.meta.env, failing fast with a clear
 * error so missing dev/prod Vite env vars don't silently become "undefined"
 * embedded in the auth flow.
 */
interface RuntimeConfig {
  oidcAuthority?: string;
  oidcClientId?: string;
}

/**
 * Served by the API at /runtime-config.js (loaded by index.html before the
 * bundle), so one image signs in against whichever realm its deployment
 * points at. Falls back to the build-time Vite env when absent (vite dev).
 */
const runtime: RuntimeConfig =
  (typeof window !== 'undefined'
    ? (window as unknown as { __FLUENTIX_CONFIG__?: RuntimeConfig }).__FLUENTIX_CONFIG__
    : undefined) ?? {};

function required(key: string, override?: string): string {
  if (override) return override;
  const value = (import.meta.env as Record<string, string | undefined>)[key];
  if (typeof value !== 'string' || value.length === 0) {
    throw new Error(
      `Missing required Vite env var ${key}. Copy web/.env.example to web/.env.local and fill it in.`,
    );
  }
  return value;
}

export const env = {
  keycloakAuthority: required('VITE_KEYCLOAK_AUTHORITY', runtime.oidcAuthority),
  keycloakClientId: required('VITE_KEYCLOAK_CLIENT_ID', runtime.oidcClientId),
  appBaseUrl:
    import.meta.env.VITE_APP_BASE_URL ??
    (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:5173'),
};
